// extracted by mini-css-extract-plugin
export default {"root":"styles_root__XLJAg","bg":"styles_bg__E9HNM","container":"styles_container__albl0"};